/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export const apiUrl = process.env.JUSTICE_BASE_URL || "https://dev.accelbyte.io";
export const publisherNamespace = process.env.JUSTICE_PUBLISHER_NAME || "accelbyte";
export const legalWebURL = process.env.JUSTICE_LEGAL_WEB_URL || "/legal";
export const isCaptchaValidationEnabled = process.env.JUSTICE_LOGINWEB_ENABLE_CAPTCHA_VALIDATION || "false";
export const isDisplayNameDisabled = process.env.JUSTICE_LOGINWEB_DISABLE_DISPLAY_NAME || "false";
export const isUsernameDisabled = process.env.JUSTICE_LOGINWEB_DISABLE_USER_NAME || "false";
export const adminPortalClientId = process.env.JUSTICE_ADMINPORTAL_CLIENT_ID || "";
export const googleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID || "";
export const zendeskKey = process.env.STARBREEZE_ZENDESK_KEY || "";
